/**
 * Citation formatting.
 *
 * Every collected quote carries its own source, so a teammate can drop it
 * straight into a speech, deck or film. The house copy rule bans em dashes, so
 * the attribution uses a spaced hyphen.
 */

/** A quote plus enough source to cite it. */
export interface Citation {
  readonly quote: string;
  readonly speaker: string;
  readonly title: string;
  readonly url: string;
  /** Seconds into the video the quote begins. */
  readonly t: number;
}

/** A YouTube URL that opens the video at `seconds`. */
export function youtubeTimeUrl(url: string, seconds: number): string {
  const t = Math.max(0, Math.floor(seconds));
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}t=${t}`;
}

/** `"<quote>" - <speaker>, <title> (<url>?t=<seconds>)`. */
export function formatCitation(citation: Citation): string {
  const source = youtubeTimeUrl(citation.url, citation.t);
  return `"${citation.quote}" - ${citation.speaker}, ${citation.title} (${source})`;
}
